// extracted by mini-css-extract-plugin
export var skipLink = "gm_xR";